// ── Core entity types and protocol definitions ──
/** Entity type discriminator — client uses this to decide how to render */
export var EntityType;
(function (EntityType) {
    EntityType["Player"] = "player";
    EntityType["Enemy"] = "enemy";
    EntityType["Loot"] = "loot";
    EntityType["Boulder"] = "boulder";
})(EntityType || (EntityType = {}));
/** Player vocation archetype */
export var Vocation;
(function (Vocation) {
    Vocation["Warrior"] = "warrior";
    Vocation["Mage"] = "mage";
    Vocation["Rogue"] = "rogue";
})(Vocation || (Vocation = {}));
/** Enemy AI behavior state */
export var AIState;
(function (AIState) {
    AIState["Idle"] = "idle";
    AIState["Patrol"] = "patrol";
    AIState["Chase"] = "chase";
    AIState["WindUp"] = "wind_up";
    AIState["Teleport"] = "teleport";
    AIState["Stealth"] = "stealth";
    AIState["Dash"] = "dash";
    AIState["Summoning"] = "summoning";
    // ── Ritual Unburdening states (Phase C) ──
    AIState["Resting"] = "resting";
    AIState["Remembering"] = "remembering";
    AIState["Aware"] = "aware";
    AIState["Settling"] = "settling";
    AIState["Displaced"] = "displaced";
    // ── Legacy aliases (kept for AI controller compat until full migration) ──
    AIState["Attack"] = "attack";
    AIState["Retreat"] = "retreat";
    AIState["Cooldown"] = "cooldown";
    AIState["Dead"] = "dead";
    AIState["Enraged"] = "enraged";
})(AIState || (AIState = {}));
/** Enemy type identifiers for data-driven config lookup */
export var EnemyType;
(function (EnemyType) {
    EnemyType["OneWhoForgotToStop"] = "melee_rusher";
    EnemyType["OneWhoKeptAiming"] = "ranged_attacker";
    EnemyType["OneWhoHeldTheLine"] = "shielded_tank";
    EnemyType["OneWhoCouldNotStandStill"] = "teleporting_caster";
    EnemyType["TheOneWhoForgotHowToBeFinished"] = "dungeon_boss";
    EnemyType["OneWhoDissolved"] = "shadow_assassin";
    EnemyType["OneWhoKeptCompany"] = "necromancer";
    EnemyType["OneWhoBrieflyRemembered"] = "berserker";
    EnemyType["HollowWarden"] = "hollow_warden";
    EnemyType["Duneshade"] = "duneshade";
    EnemyType["FrostboundMatriarch"] = "frostbound_matriarch";
    EnemyType["EmberbornJuggernaut"] = "emberborn_juggernaut";
})(EnemyType || (EnemyType = {}));
/** Attack pattern identifiers for enemies */
export var AttackPattern;
(function (AttackPattern) {
    AttackPattern["Melee"] = "melee";
    AttackPattern["Ranged"] = "ranged";
    AttackPattern["AoE"] = "aoe";
})(AttackPattern || (AttackPattern = {}));
//# sourceMappingURL=entities.js.map